import React, { Component, createRef } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddCompanyForm from "./AddCompanyForm";
import AddCompanyFormForProposals from "./AddCompanyFormForProposals";

class AddUserModal extends Component {
  constructor(props) {
    super(props);
    this.formRef = createRef();  // Equivalent to useRef in functional components
  }

  handleSubmit = () => {
    // Check if formRef is valid and call the handleSubmit function inside AddCompanyForm
    if (this.formRef.current && typeof this.formRef.current.handleSubmit === 'function') {
      this.formRef.current.handleSubmit();
    } else {
      console.error('Form ref or handleSubmit is not correctly set');
    }
  };

  handleConfirm = async () => {
    console.log('Form ref on confirm:', this.formRef.current);
    this.handleSubmit(); // Call handleSubmit from the form component
    
    setTimeout(async () => {
      if (this.props.getCompanyNames) {
        await this.props.getCompanyNames();
      }
    }, 500);
  };

  render() {
    const { isOpen, onCancel, proposalEditor = false, showDownloadDocsModal, getAgency, companyGroupNames } = this.props;

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>Add New Company</ModalHeader>
        <ModalBody>
          {
            !proposalEditor ?
              <AddCompanyForm
                ref={this.formRef}
                onConfirm={this.props.onConfirm}
                companyGroupNames={companyGroupNames}
              /> :
              <AddCompanyFormForProposals
                showDownloadDocsModal={showDownloadDocsModal}
                getAgency={getAgency}
              />
          }
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
          <Button color="primary" onClick={this.handleConfirm} id="company-submit-btn">
            {
              !proposalEditor ? 'Submit' : 'Add new Companys'
            }
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddUserModal;
